export const dateType = {
  filter: 'agDateColumnFilter',
  cellRenderer: (param) => param.value.toLocaleString(),
};
